import { Button, Box, Flex } from '@sequencehq/core-components'
import {
  GreyGrey20,
  GreyGrey70,
  GreyGrey80,
  Primary13SemiBold,
  Primary13Regular
} from '@sequencehq/core-components'
import { IntegrationsBrowserModal } from 'Integrations/view/integrationsBrowserModal/IntegrationsBrowserModal'
import { ReactNode } from 'react'
import { AvailableServices } from 'Integrations/domain'
import { ProtectedButton } from 'lib/rbac'

export const NotConnectedItemContent = (props: {
  service: AvailableServices
  serviceName: string
  serviceDescription: string
  'data-testid'?: string
  logo: ReactNode
  // Defaults to the inspector rail's width; the settings page fills its column.
  width?: string
}) => (
  <Flex
    width={props.width ?? '320px'}
    height="100%"
    overflow="auto"
    padding="16px"
    gap="16px"
    data-testid={props['data-testid']}
    alignItems="center"
    justifyContent="center"
    flexDirection="column"
  >
    <Box
      padding="6px"
      borderRadius="6px"
      backgroundColor={GreyGrey20}
      width="fit-content"
    >
      {props.logo}
    </Box>
    <Flex flexDirection="column" gap="4px" alignItems="center">
      <Box {...Primary13SemiBold} color={GreyGrey80}>
        {props.serviceName} is not connected
      </Box>
      <Box {...Primary13Regular} color={GreyGrey70} textAlign="center">
        {props.serviceDescription}
      </Box>
    </Flex>
    <IntegrationsBrowserModal
      trigger={
        <ProtectedButton permission="org.integration:create">
          <Button
            variant={'secondary'}
            data-testid={`notConnected.${props.service}.connectTo`}
          >
            Connect to {props.serviceName}
          </Button>
        </ProtectedButton>
      }
      defaultService={props.service}
    />
  </Flex>
)
